<template>
  <div>
    <!-- begin breadcrumb -->
    <breadcrumb activeName="商品目录" :breadcrumbItem="[{to:'/artical/categroy',name:'商品目录'}]"></breadcrumb>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      商品目录
      <small>维护商品的目录...</small>
    </h1>
    <!-- end page-header -->
    <panel title="商品目录: 系统按三级目录组织" :noButton="true">
      <div slot="heading-btn">
        <button class="btn btn-theme btn-sm" type="button" @click="fn_add">
          <i class="fa fa-plus"></i> 增加目录
        </button>
      </div>
      <zk-table
        ref="table"
        sum-text="sum"
        index-text="#"
        :data="data"
        :columns="columns"
        :stripe="props.stripe"
        :border="props.border"
        :show-header="props.showHeader"
        :show-summary="props.showSummary"
        :show-row-hover="props.showRowHover"
        :show-index="props.showIndex"
        :tree-type="props.treeType"
        :is-fold="props.isFold"
        :expand-type="props.expandType"
        :selection-type="props.selectionType"
      >
        <template slot="$expand" slot-scope="{row}">
          {{ `My name is ${row.name},
          this rowIndex is ${row.id}.`
          }}
        </template>
        <template slot="logo" slot-scope="{row}">
          <img v-if="row.logo" :src="logourl+row.logo" style="max-height:100px" />
        </template>
        <template slot="name" slot-scope="{row}">[{{row.id}}]{{row.name}}</template>
        <template slot="keywords" slot-scope="{row}">{{row.keywords}}</template>
        <template slot="is_show" slot-scope="{row}">
          <span v-if="row.is_show">显示</span>
          <span v-else>不显示</span>
        </template>
        <template slot="is_show_nav" slot-scope="{row}">
          <span v-if="row.is_show_nav">显示</span>
          <span v-else>不显示</span>
        </template>
        <template slot="is_feature" slot-scope="{row}">
          <span v-if="row.is_feature">
            <i class="fa fa-check"></i>
          </span>
        </template>

        <template slot="action" slot-scope="{row}">
          <button class="btn btn-theme btn-sm" type="button" @click="fn_edit(row)">修改</button>

          <Poptip
            v-if="row.goodscount ==0"
            class="m-l-3"
            transfer
            confirm
            title="确认要删除这商品目录?"
            @on-ok="fn_remove(row)"
            ok-text="确认"
            cancel-text="取消"
          >
            <button class="btn btn-danger btn-sm" type="button" ghost>删除</button>
          </Poptip>
        </template>
      </zk-table>
    </panel>

    <Drawer title="商品目录" v-model="v_edit_category" width="720" :mask-closable="true">
      <Form :model="formData" ref="formData" :rules="rules" :labelWidth="120">
        <FormItem label="类型名称" label-position="top" prop="name">
          <Input v-model="formData.name" placeholder="商品目录名称" :maxlength="90" />
        </FormItem>
        <FormItem label="上级" prop="pid">
          <Treeselect v-model="formData.pid" :multiple="false" :options="categoryTree" />
        </FormItem>
        <FormItem label="关键字" label-position="top" prop="keywords">
          <Input v-model="formData.keywords" placeholder="关键字" :maxlength="255" />
        </FormItem>

        <FormItem label="描述" label-position="top">
          <Input type="textarea" v-model="formData.description" :rows="4" placeholder="目录详细描述" />
        </FormItem>
        <FormItem label="Logo">
          <Row :gutter="3">
            <Col span="10">
              <Upload
                name="filename"
                :show-upload-list="false"
                :action="uploadhost"
                :format="['jpg','jpeg','png']"
                :on-success="fn_uploadSuccess"
                :max-size="2048"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                style="display: inline-block;width:90px;"
              >
                <Button icon="ios-cloud-upload-outline">上传Logo[660*260]</Button>
              </Upload>
            </Col>
            <Col span="10">
              <img :src="logourl+formData.logo" style="max-height:100px" />
            </Col>
          </Row>
        </FormItem>
        <FormItem label="排序" label-position="top">
          <InputNumber v-model="formData.sortval" :min="0"></InputNumber>
        </FormItem>
        <FormItem label="是否显示">
          <RadioGroup v-model="formData.is_show">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </RadioGroup>

          <small class="f-s-12 text-grey-darker">如果不显示,则只作为数据目录</small>
        </FormItem>
        <FormItem label="显示在导航">
          <RadioGroup v-model="formData.is_show_nav">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <button
          type="button"
          class="btn btn-default"
          style="margin-right: 8px"
          @click="v_edit_category = false"
        >关闭</button>
        <button type="button" class="btn btn-theme" @click="fn_store_data">保存</button>
      </div>
    </Drawer>
  </div>
</template>
<script>
import breadcrumb from "@/components/breadcrumb";
import ZkTable from "vue-table-with-tree-grid";
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {
  getCategoryTreeTableData,
  getCategoryTreeSelect,
  storeCategoryData,
  removeCategoryData
} from "@/api/artical";
import config from "@/config";

export default {
  components: { breadcrumb, ZkTable, Treeselect },
  data() {
    return {
      uploadhost: config.baseUrl.pro + "/upload/uploadfile",
      logourl: config.baseUrl.imageurl,
      v_edit_category: false,
      props: {
        stripe: false,
        border: true,
        showHeader: true,
        showSummary: false,
        showRowHover: false,
        showIndex: true,
        treeType: true,
        isFold: false,
        expandType: false,
        selectionType: false
      },
      data: [],
      columns: [
        {
          label: "目录名称",
          prop: "name",
          width: "250px"
        },
        {
          label: "目录LOGO",
          prop: "logo",
          type: "template",
          template: "logo",
          width: 300
        },

        {
          label: "是否显示",
          prop: "is_show",
          type: "template",
          template: "is_show",
          width: 100
        },
        {
          label: "显示在导航",
          prop: "is_show_nav",
          type: "template",
          template: "is_show_nav",
          width: 100
        },
        {
          label: "排序",
          prop: "sortval",
          width: 80
        },
        {
          label: "文章数",
          prop: "articalcount",
          width: 80
        },
        {
          label: "操作",
          prop: "action",
          type: "template",
          template: "action",
          width: 150
        }
      ],

      currentPage: 1,
      totalRows: 0,

      formData: {
        id: 0,
        name: "",
        keywords: "",
        description: "",
        pid: 0,
        logo: "",
        sortval: 0,
        is_show_nav: 0,
        is_show: 0
      },
      rules: {
        name: [
          {
            required: true,
            message: "名称必填",
            tirgger: "blur"
          }
        ]
      },
      categoryTree: []
    };
  },
  mounted() {
    this.fn_load_data();
    getCategoryTreeSelect()
      .then(res => {
        this.categoryTree = [
          {
            id: 0,
            label: "顶级节点",
            children: res.data
          }
        ];
      })
      .catch(error => {
        this.$Message.error(error);
      });
  },
  methods: {
    fn_load_data() {
      getCategoryTreeTableData()
        .then(res => {
          this.data = res.data;
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_add() {
      this.v_edit_category = true;
      this.formData = {
        id: 0,
        name: "",
        keywords: "",
        description: "",
        pid: 0,
        logo: "",
        sortval: 0,
        is_show_nav: 0,
        is_show: 0,
        is_feature: 0
      };
    },
    fn_edit(row) {
      this.formData = row;
      this.v_edit_category = true;
    },
    fn_uploadSuccess(res, file) {
      if (file.response.code === 200) {
        this.formData.logo = file.response.data;
      }
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc:
          "文件 " + file.name + " 格式不正确，请上传 jpg 或 png 格式的图片。"
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "超出文件大小限制",
        desc: "文件 " + file.name + " 太大，不能超过 2M。"
      });
    },
    fn_store_data() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          storeCategoryData(this.formData)
            .then(res => {
              if (res.data.code == 200) {
                this.$Notice.success(res.data);
                this.v_edit_category = false;
                if (this.formData.id == 0) {
                  this.fn_load_data();
                }
              }
            })
            .catch(error => {
              this.$Message.error(error);
            });
        }
      });
    },
    fn_remove(row) {
      removeCategoryData(row.id)
        .then(res => {
          if (res.data.code == 200) {
            this.$Notice.success(res.data);
            this.fn_load_data();
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    }
  }
};
</script>
<style scoped>
.zk-table__footer-row,
.zk-table__header-row {
  height: 30px;
}
</style>